export { ScriptBehaviour, HTMLComponent, HTMLComponentProps } from "./components/HTMLComponent";
